/** Caps planned activities carried in the interest context slice. */
export const ASSISTANT_INTEREST_PLANNED_ACTIVITIES_MAX_ITEMS = 10;
